var $radius_0 = 0;

/**
 * 边框圆角-直角
 * @description enDesc: Right angle
 * @description type: alias
 * @description  globalToken: $radius-0
 * @description  value: 0
 */
var $radius_border_none = $radius_0;

/**
 * 边框圆角--小
 * @description enDesc: Border radius - regular
 * @description type: global
 * @description  globalToken: $radius-1
 * @description  value: 4px
 */
var $radius_border_sm = 4;

/**
 * 边框圆角--常规
 * @description enDesc: Border radius - medium
 * @description type: global
 * @description  globalToken: $radius-2
 * @description  value: 8px
 */
var $radius_border_base = 8;

/**
 * 边框圆角-大
 * @description enDesc: Border radius - larger
 * @description type: global
 * @description  globalToken: $radius-3
 * @description  value: 16px
 */
var $radius_border_lg = 16;

/**
 * 边框圆角-加大
 * @description enDesc: Border radius - larger
 * @description type: global
 * @description  globalToken: $radius-4
 * @description  value: 16px
 */
var $radius_border_xlg = 16;

/**
 * 边框圆角-全圆角
 * @description enDesc: Total border radius
 * @description type: global
 * @description  globalToken: $radius-5
 * @description  value: 50%
 */
var $radius_border_circle = '50%';

/**
 * 边框粗细-无边框
 * @description enDesc: No border
 * @description type: global
 * @description  globalToken: $line-size-0
 * @description  value: 0
 */
var $line_size_border_none = 0;

/**
 * 边框粗细-常规
 * @description enDesc: Regular
 * @description type: global
 * @description  globalToken: $line-size-1
 * @description  value: 1px
 */
var $line_size_border_primary = 1;

/**
 * 边框粗细-较粗
 * @description enDesc: Thicker
 * @description type: global
 * @description  globalToken: $line-size-2
 * @description  value: 2px
 */
var $line_size_border_secondary = 2;

/**
 * 边框粗细-加粗
 * @description enDesc: Rough
 * @description type: global
 * @description  globalToken: $line-size-2
 * @description  value: 3px
 */
var $line_size_border_tertiary = 3;

/**
 * 边框样式-实线
 * @description enDesc: Solid line
 * @description type: global
 * @description  globalToken: $line-style-solid
 * @description  value: solid
 */
var $line_style_border_solid = 'solid';

/**
 * 边框样式-虚线
 * @description enDesc: Dashed line
 * @description type: global
 * @description  globalToken: $line-style-dashed
 * @description  value: dashed
 */
var $line_style_border_dashed = 'dashed';

/**
 * 边框样式-点线
 * @description enDesc: Dotted line
 * @description type: global
 * @description  globalToken: $line-style-dotted
 * @description  value: dotted
 */
var $line_style_border_dotted = 'dotted';

export { $line_size_border_none, $line_size_border_primary, $line_size_border_secondary, $line_size_border_tertiary, $line_style_border_dashed, $line_style_border_dotted, $line_style_border_solid, $radius_0, $radius_border_base, $radius_border_circle, $radius_border_lg, $radius_border_none, $radius_border_sm, $radius_border_xlg };
